/**
 * Format a phone number for display. US numbers are formatted as
 * `+1 (555) 456-7890` (or `(555) 456-7890` when `showCountryCode` is false).
 * Accepts `+1`-prefixed, bare 10-digit, and `1`-prefixed 11-digit inputs —
 * atlas-web is US-only, so a 10-digit string is treated as US. Anything with a
 * non-`+1` country code or an unparseable shape is returned unchanged. Returns
 * `null` for null/empty input.
 */
export const formatPhoneNumber = (phone: string | null | undefined, showCountryCode = true): string | null => {
  if (!phone) return null

  const cleaned = phone.replace(/\D/g, '')
  const hasNonUSCountryCode = phone.trim().startsWith('+') && !phone.trim().startsWith('+1')
  const match = !hasNonUSCountryCode ? cleaned.match(/^1?(\d{3})(\d{3})(\d{4})$/) : null

  if (match) {
    return showCountryCode ? `+1 (${match[1]}) ${match[2]}-${match[3]}` : `(${match[1]}) ${match[2]}-${match[3]}`
  }

  return phone
}

/** Normalize a display phone string into a `tel:` URI. */
export const formatTelHref = (phone: string): string => {
  const [baseNumber = phone] = phone.split(/(?:\s*(?:ext(?:ension)?\.?|x)\s*)\d/i, 1)
  const trimmed = baseNumber.trim()
  const telValue = `${trimmed.startsWith('+') ? '+' : ''}${trimmed.replace(/\D/g, '')}`
  return `tel:${telValue.length > 0 ? telValue : phone}`
}
